var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "eventos-table" },
    [
      _c("BaseTable", {
        attrs: {
          title: _vm.title,
          "custom-sort": _vm.customSort,
          headers: _vm.headers,
          items: _vm.eventos,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          loading: _vm.loading,
          "search-value": _vm.search,
          "disable-margin-top": ""
        },
        scopedSlots: _vm._u(
          [
            {
              key: "cornerAction",
              fn: function() {
                return [_vm._t("cornerAction")]
              },
              proxy: true
            },
            {
              key: "item.icon",
              fn: function(ref) {
                var item = ref.item
                return [_c("EventIcon", { attrs: { event: item } })]
              }
            },
            {
              key: "item.nome_ativo",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm._v(
                    " " +
                      _vm._s(
                        item.nome_ativo ||
                          (_vm.asset && _vm.asset.nome_ativo) ||
                          ""
                      ) +
                      " "
                  )
                ]
              }
            },
            {
              key: "item.operacao",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm._v(" " + _vm._s(item.operacao || "") + " "),
                  item.operacao &&
                  ["Desdobramento", "Agrupamento"].includes(item.operacao)
                    ? [
                        _c("span", [
                          _vm._v(
                            " de " + _vm._s(item.de) + ":" + _vm._s(item.para)
                          )
                        ])
                      ]
                    : _vm._e()
                ]
              }
            },
            {
              key: "item.data_com",
              fn: function(ref) {
                var item = ref.item
                return [_vm._v(" " + _vm._s(item.data_com || "") + " ")]
              }
            },
            {
              key: "item.data_pagamento",
              fn: function(ref) {
                var item = ref.item
                return [_vm._v(" " + _vm._s(item.data_pagamento || "") + " ")]
              }
            },
            {
              key: "item.quantidade",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm._v(" " + _vm._s(_vm.quantityText({ item: item })) + " ")
                ]
              }
            },
            {
              key: "item.valor",
              fn: function(ref) {
                var item = ref.item
                return [_vm._v(" " + _vm._s(item._valorText) + " ")]
              }
            },
            {
              key: "item.valor_total",
              fn: function(ref) {
                var item = ref.item
                return [
                  ["Bonificação (%)"].includes(item.operacao)
                    ? [
                        _vm._v(
                          " " +
                            _vm._s(item.valor_total) +
                            "x " +
                            _vm._s(
                              item.nome_ativo ||
                                (_vm.asset && _vm.asset.referencia)
                            ) +
                            " "
                        )
                      ]
                    : [_vm._v(" " + _vm._s(item._valorTotalText) + " ")]
                ]
              }
            },
            {
              key: "item.origem",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.FORMAT_ORIGEM[item.origem] || item.origem || "-"
                      ) +
                      " "
                  )
                ]
              }
            },
            {
              key: "item.action",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("TableRowActions", {
                    attrs: { actions: _vm.getEventActions({ item: item }) }
                  })
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }